var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"content"},[_c('ParsedMessage',{attrs:{"network":_vm.network,"message":_vm.message,"text":_vm.errorMessage}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }